import React, { useMemo } from 'react';
import { format, isToday, isYesterday } from 'date-fns';
import { DataTestId } from '@utils/test';

/**
 * This Divider will render a formatted date if passed a value as date
 * IF no value is passed, it will render the default divider
 */

const DIVIDER_DATE_FORMAT = 'LLLL dd';

export const getFormattedDate = (date: Date | undefined | null): string | null => {
  if (!date) return null;

  const dateString = format(date, DIVIDER_DATE_FORMAT);

  if (isToday(date)) {
    return `Today, ${dateString}`;
  } else if (isYesterday(date)) {
    return `Yesterday, ${dateString}`;
  } else {
    return dateString;
  }
};

export const Divider = ({ date }: { date?: Date }) => {
  const formattedDate = useMemo(() => getFormattedDate(date), [date]);

  return (
    <div
      className="flex h-[1px] w-full flex-col items-center justify-center overflow-visible py-5 md:py-10"
      data-testid={DataTestId.FEED_DIVIDER}
    >
      <div className="h-[1px] w-full flex-shrink-0 bg-base300" />
      {!!date && (
        <div
          className="absolute bg-white px-5 font-kicker text-kicker-xs uppercase text-neutral400"
          data-testid={DataTestId.FEED_DIVIDER_DATE}
        >
          {formattedDate}
        </div>
      )}
    </div>
  );
};
